import { gql } from "@apollo/client";

export const classroomQuery = gql`
  query campus($scenarioId: ID!) {
    data(scenarioId: $scenarioId) {
      classroomTypes {
        items {
          id
          code
          name
        }
      }
    }
  }
`;
